export default __webpack_public_path__ + "static/media/fa3e85c6-813f-41d2-902e-56d9225e6608.e26ac397.jpeg";